import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { PaletteUtils } from '@shared/utils';
import { Button } from '@shared/widgets';
import CheckmarkIcon from '@assets/icons/messages/checkmark.svg';

interface AskForDeleteProps {
  loading: boolean;
  onClose: () => void;
  onAction: () => void;
}

export const AskForDelete = (props: AskForDeleteProps) => {
  const { t } = useTranslation('messages');

  return (
    <div
      className={clsx(
        'flex items-center justify-center h-full opacity-100 w-full transition-opacity duration-300',
        props.loading && 'opacity-50 pointer-events-none',
      )}
    >
      <div className='bg-white text-[#27272b] text-base max-w-[400px] p-7.5'>
        <div className='flex justify-center mb-5'>
          <CheckmarkIcon className={clsx(PaletteUtils.isBordierPalette ? 'text-[#dc291c]' : 'text-[#be8b45]')} />
        </div>
        <div className='text-center mb-[20px]'>{t('modals.askForDelete.title')}</div>
        <div className='flex justify-center gap-2'>
          <Button
            className={clsx(PaletteUtils.isBordierPalette ? '' : '!border-[#6d6d75] hover:!border-[#e5c496] hover:!text-[#4c4c52]')}
            fullWidth
            view='secondary'
            caption={t('modals.askForDelete.buttons.yes')}
            onClick={props.onAction}
          />
          <Button
            className={clsx(
              PaletteUtils.isBordierPalette ? 'bg-[#dc291c]' : 'bg-[#e5c496] border-[#e5c496] hover:bg-transparent hover:text-[#4c4c52]',
            )}
            fullWidth
            view='secondary'
            caption={t('modals.askForDelete.buttons.no')}
            active
            onClick={props.onClose}
          />
        </div>
      </div>
    </div>
  );
};
